import { z } from 'zod'

/** Storefronts and marketplace channels are intentionally separate capabilities. */
export const storefrontShopIds = [101, 201, 202, 203, 204, 205] as const
export const storefrontShopSchema = z.union([
  z.literal(101), z.literal(201), z.literal(202),
  z.literal(203), z.literal(204), z.literal(205),
])
export const marketplaceShopSchema = z.union([z.literal(1001), z.literal(1002)])
export const knownShopSchema = z.union([storefrontShopSchema, marketplaceShopSchema])
